<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',

  // mounted() {
  //   setTimeout(()=>{
  //     if (this.$route.query.scode) {
  //       localStorage.setItem('scode', this.$route.query.scode)
  //     }
  //   },500)
  // }
}
</script>

<style>
#app {
  font-family: 'Avenir', SimSun, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 0px;
  background-color: #F5F7F9;
}

body{
  background-color: #F5F7F9;
}

#nprogress .bar {
  background: #0F4172 !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue